module.exports = __webpack_public_path__ + "img/confetti_2b.fb2d4360.svg";